import { render, staticRenderFns } from "./GlassBatchInsertForm.vue?vue&type=template&id=23ca80a4&scoped=true&"
import script from "./GlassBatchInsertForm.vue?vue&type=script&lang=js&"
export * from "./GlassBatchInsertForm.vue?vue&type=script&lang=js&"
import style0 from "./GlassBatchInsertForm.vue?vue&type=style&index=0&id=23ca80a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ca80a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VChip,VCol,VDataTable,VRow})
